import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';

import { DateFormatPipe } from '../../../common/util/date-format.pipe';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { ActivityStoreFacade } from '../../../common/facade/ActivityStoreFacade';
import { StoreDetailReportDto } from '../../../common/model/dto/StoreDetailReportDto';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-store-report-detail',
  templateUrl: './store-report-detail.component.html',
  styleUrls: ['./store-report-detail.component.css'],
})
export class StoreReportDetailComponent implements OnInit {
  titleStore = res.Store;
  lblDownload = res.Download;
  lblRequiredDate = res.RequiredDate;
  lblCompliance = res.Compliance;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: '',
  };

  isSpanish = true;

  public loading = false;
  public messageLoader = '';
  public backToVisible = true;
  public _storeId: number;
  private _catDetTaskTypeId: number;
  private _startDate: string;
  private _endDate: string;
  private _organizationId: string;
  private _task: string;
  public TitleActivity: string;
  public lstStoreReport: StoreDetailReportDto[];
  public storeReport: StoreDetailReportDto;
  public _filteredData = [];
  public alerts: any[];
  public extras: NavigationExtras;
  public path = 'StoreReport';

  constructor(
    private _facade: ActivityStoreFacade,
    private _route: ActivatedRoute,
    private _datePipe: DatePipe,
    private _excel: ExcelUtility,
    private _dateFormatPipe: DateFormatPipe,
    public strings: Strings
  ) {}

  ngOnInit() {
    this.messagesTable.emptyMessage = this.strings.GetText(
      res.ThereIsNoInformation
    );
    this.messagesTable.totalMessage = 'Total';
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.goToInicialize();
  }

  goToInicialize() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);

    this._storeId = Number.parseInt(
      this._route.snapshot.paramMap.get('storeId').toString()
    );
    this._catDetTaskTypeId = Number.parseInt(
      this._route.snapshot.paramMap.get('taskTypeId').toString()
    );
    this._startDate = this._route.snapshot.paramMap.get('startDate');
    this._endDate = this._route.snapshot.paramMap.get('endDate');
    this._organizationId = this._route.snapshot.paramMap.get('organizationId');
    
    this._facade
      .GetDetailReport(
        this._storeId,
        this._catDetTaskTypeId,
        this._startDate,
        this._endDate
      )
      .subscribe(
        (result) => {
          if (result.completed) {
            const startDate = new Date(this._startDate);
            const endDate = new Date(this._endDate);
            this.lstStoreReport = result.data;
            this._filteredData = result.data;
            this._task = this.findTask(this._catDetTaskTypeId);
            if (this.isSpanish) {
              this.TitleActivity =
                this._task +
                ' de ' +
                this._datePipe.transform(startDate, 'dd/MM/yyyy') +
                ' a ' +
                this._datePipe.transform(endDate, 'dd/MM/yyyy');
            } else {
              this.TitleActivity =
                this._task +
                ' of ' +
                this._datePipe.transform(startDate, 'MM/dd/yyyy') +
                ' to ' +
                this._datePipe.transform(endDate, 'MM/dd/yyyy');
            }
            this.extras = {
              queryParams: {
                startDate: this._startDate,
                endDate: this._endDate,
                orgId: this._organizationId,
              },
            };
          } else {
            this.addAlert('<strong>' + result.message + '</strong>', 'danger');
          }
          this.loading = false;
        },
        (error) => {
          this.addAlert('<strong>' + error + '</strong>', 'danger');
          this.loading = false;
        }
      );
  }
  // añadir alert
  addAlert(message: String, type: String): void {
    this.alerts = [];
    this.alerts.push({ type: type, msg: message });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
  }

  findTask(task) {
    let t: string;
    switch (task) {
      case 103:
        t = this.strings.GetText(res.TitleOpening);
        break;
      case 104:
        t = this.strings.GetText(res.TitleClosing);
        break;
      case 102:
        t = this.strings.GetText(res.ChangeMarketingCampaign);
        break;
      case 113:
        t = this.strings.GetText(res.Reception);
        break;
      case 112:
        t = this.strings.GetText(res.Received);
        break;
      case -2:
        t = this.strings.GetText(res.Reception);
        break;
      case -1:
        t = this.strings.GetText(res.MerchandiseEntry);
        break;
    }

    return t;
  }
  /**
   * Método para descargar el reporte de las tiendas
   */
  downloadLayout() {
    if (this.lstStoreReport.length > 0) {
      const data: any = [];
      this.lstStoreReport.forEach((row) => {
        const info = {
          [this.strings.GetText(res.Store)]: row.storeId,
          [this.strings.GetText(res.StoreType)]: this._task,
          [this.strings.GetText(res.RequiredDate)]:
            this._dateFormatPipe.transform(row.requiredDate),
          [this.strings.GetText(res.CompliancePercentage)]: row.percentComplete,
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, 'data');
    } else {
      this.addAlert(this.strings.GetText(res.AlertNoInfoToDownload), 'danger');
    }
  }
}
